import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'applicant-tracker.field-1-name': {
    id: 'applicant-tracker.field-1-name',
    defaultMessage: 'Candidate',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Candidate'
  },
  'applicant-tracker.field-2-name': {
    id: 'applicant-tracker.field-2-name',
    defaultMessage: 'Stage',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Stage'
  },
  'applicant-tracker.field-2-select-option-1': {
    id: 'applicant-tracker.field-2-select-option-1',
    defaultMessage: 'No hire',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: No hire'
  },
  'applicant-tracker.field-2-select-option-2': {
    id: 'applicant-tracker.field-2-select-option-2',
    defaultMessage: 'Interviewing',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Interviewing'
  },
  'applicant-tracker.field-2-select-option-3': {
    id: 'applicant-tracker.field-2-select-option-3',
    defaultMessage: 'Lead',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Lead'
  },
  'applicant-tracker.field-2-select-option-4': {
    id: 'applicant-tracker.field-2-select-option-4',
    defaultMessage: 'Offer extended',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Offer extended'
  },
  'applicant-tracker.field-2-select-option-5': {
    id: 'applicant-tracker.field-2-select-option-5',
    defaultMessage: 'Hired',
    description:
      'The option value for option #5 in field #2 for this database template. In this case: Hired'
  },
  'applicant-tracker.field-3-name': {
    id: 'applicant-tracker.field-3-name',
    defaultMessage: 'Role',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Role'
  },
  'applicant-tracker.field-3-select-option-1': {
    id: 'applicant-tracker.field-3-select-option-1',
    defaultMessage: 'HR',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: HR'
  },
  'applicant-tracker.field-3-select-option-2': {
    id: 'applicant-tracker.field-3-select-option-2',
    defaultMessage: 'Product Designer',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: Product Designer'
  },
  'applicant-tracker.field-3-select-option-3': {
    id: 'applicant-tracker.field-3-select-option-3',
    defaultMessage: 'Security Engineer',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: Security Engineer'
  },
  'applicant-tracker.field-3-select-option-4': {
    id: 'applicant-tracker.field-3-select-option-4',
    defaultMessage: 'Product Manager',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: Product Manager'
  },
  'applicant-tracker.field-3-select-option-5': {
    id: 'applicant-tracker.field-3-select-option-5',
    defaultMessage: 'Software Engineer',
    description:
      'The option value for option #5 in field #3 for this database template. In this case: Software Engineer'
  },
  'applicant-tracker.field-3-select-option-6': {
    id: 'applicant-tracker.field-3-select-option-6',
    defaultMessage: 'UX Researcher',
    description:
      'The option value for option #6 in field #3 for this database template. In this case: UX Researcher'
  },
  'applicant-tracker.field-4-name': {
    id: 'applicant-tracker.field-4-name',
    defaultMessage: 'Recruiting start',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Recruiting start'
  },
  'applicant-tracker.field-5-name': {
    id: 'applicant-tracker.field-5-name',
    defaultMessage: 'Hiring manager',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Hiring manager'
  },
  'applicant-tracker.field-6-name': {
    id: 'applicant-tracker.field-6-name',
    defaultMessage: 'Location',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Location'
  },
  'applicant-tracker.field-7-name': {
    id: 'applicant-tracker.field-7-name',
    defaultMessage: 'Interview notes',
    description:
      'The field name (and the default value/watermark) in field #7 for this database template. In this case: Interview notes'
  },
  'applicant-tracker.view-1-name': {
    id: 'applicant-tracker.view-1-name',
    defaultMessage: 'All applicants',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All applicants'
  },
  'applicant-tracker.entry-1-cell-6': {
    id: 'applicant-tracker.entry-1-cell-6',
    defaultMessage: 'San Ramon, CA',
    description:
      'The text value of cell #6 in row (entry) #1 in this database template. In this case:  San Ramon, CA'
  },
  'applicant-tracker.entry-1-cell-7': {
    id: 'applicant-tracker.entry-1-cell-7',
    defaultMessage: 'Demonstrates data driven decision making',
    description:
      'The text value of cell #7 in row (entry) #1 in this database template. In this case: Demonstrates data driven decision making'
  },
  'applicant-tracker.entry-2-cell-6': {
    id: 'applicant-tracker.entry-2-cell-6',
    defaultMessage: 'Los Angeles, CA',
    description:
      'The text value of cell #6 in row (entry) #2 in this database template. In this case:  Los Angeles, CA'
  },
  'applicant-tracker.entry-2-cell-7': {
    id: 'applicant-tracker.entry-2-cell-7',
    defaultMessage: 'Experience with moderating in-person and remote sessions',
    description:
      'The text value of cell #7 in row (entry) #2 in this database template. In this case:  Experience with moderating in-person and remote sessions'
  },
  'applicant-tracker.entry-3-cell-6': {
    id: 'applicant-tracker.entry-3-cell-6',
    defaultMessage: 'San Diego, CA',
    description:
      'The text value of cell #6 in row (entry) #3 in this database template. In this case:  San Diego, CA'
  },
  'applicant-tracker.entry-3-cell-7': {
    id: 'applicant-tracker.entry-3-cell-7',
    defaultMessage:
      'Strong background in recruitment across tech and healthcare industries',
    description:
      'The text value of cell #7 in row (entry) #3 in this database template. In this case:  Strong background in recruitment across tech and healthcare industries'
  },
  'applicant-tracker.entry-4-cell-6': {
    id: 'applicant-tracker.entry-4-cell-6',
    defaultMessage: 'Chicago, IL',
    description:
      'The text value of cell #6 in row (entry) #4 in this database template. In this case:  Chicago, IL'
  },
  'applicant-tracker.entry-4-cell-7': {
    id: 'applicant-tracker.entry-4-cell-7',
    defaultMessage:
      'Extensive background in systems architecture and backend development',
    description:
      'The text value of cell #7 in row (entry) #4 in this database template. In this case:  Extensive background in systems architecture and backend development'
  },
  'applicant-tracker.entry-5-cell-6': {
    id: 'applicant-tracker.entry-5-cell-6',
    defaultMessage: 'Irvine, CA',
    description:
      'The text value of cell #6 in row (entry) #5 in this database template. In this case:  Irvine, CA'
  },
  'applicant-tracker.entry-5-cell-7': {
    id: 'applicant-tracker.entry-5-cell-7',
    defaultMessage: 'Demonstrates clear understanding of stack data structures',
    description:
      'The text value of cell #7 in row (entry) #5 in this database template. In this case:  Demonstrates clear understanding of stack data structures'
  },
  'applicant-tracker.entry-6-cell-6': {
    id: 'applicant-tracker.entry-6-cell-6',
    defaultMessage: 'Mountain View, CA',
    description:
      'The text value of cell #6 in row (entry) #6 in this database template. In this case:  Mountain View, CA'
  },
  'applicant-tracker.entry-6-cell-7': {
    id: 'applicant-tracker.entry-6-cell-7',
    defaultMessage: 'Gave solid example of symmetric and asymmetric encryption',
    description:
      'The text value of cell #7 in row (entry) #6 in this database template. In this case:  Gave solid example of symmetric and asymmetric encryption'
  },
  'applicant-tracker.entry-7-cell-5': {
    id: 'applicant-tracker.entry-7-cell-5',
    defaultMessage: 'San Antonio, TX',
    description:
      'The text value of cell #5 in row (entry) #7 in this database template. In this case:  San Antonio, TX'
  },
  'applicant-tracker.entry-7-cell-6': {
    id: 'applicant-tracker.entry-7-cell-6',
    defaultMessage: 'Demonstrates clear understanding of interaction and visual design',
    description:
      'The text value of cell #6 in row (entry) #7 in this database template. In this case:  Demonstrates clear understanding of interaction and visual design'
  }
});
